import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import CustomizedTable from "../../../../CustomizedTable/CustomizedTable";
import { DefaultCell } from "../../../../CustomizedTable/CustomCells/CustomCells";

export default function CarrierOffersModalComments({ comments }) {
  const loadComments = useMemo(() => comments, [comments]);
  const columns = useMemo(
    () => [
      {
        Header: "Rep",
        accessor: "enteredUserId",
        filter: "fuzzyText",
        width: 100,
        Cell: DefaultCell,
      },
      {
        Header: "Comments",
        accessor: "comments",
        filter: "fuzzyText",
        width: 560,
        Cell: DefaultCell
      }
    ]
  );

  return (
    comments.length > 0 &&
    <Box sx={{ marginBottom: "20px" }}>
      <span style={{ display: "flex", alignItems: "center" }}>
        <Typography variant="h3" color="primary.60">
          Rate Con Comments
        </Typography>
      </span>
      <Box sx={{ maxHeight: "200px", overflow: "auto" }}>
        <CustomizedTable
          id="hot-comments"
          columns={columns}
          data={loadComments}
          defaultHeight={loadComments.length * 32}
          defaultWidth={700}
        />
      </Box>
    </Box>
  );
}

CarrierOffersModalComments.propTypes = {
  comments: PropTypes.array
};